(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faq-accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function closeFaqItems(scope) {
      scope.querySelectorAll('.faq-item').forEach(function (faqItem) {
        faqItem.classList.remove('active');
        const openAnswer = faqItem.querySelector('.faq-answer');
        if (openAnswer) openAnswer.style.maxHeight = null;
      });
    }

    function setGroupOpen(group, isOpen) {
      const toggle = group.querySelector('.faq-group__toggle');
      const panel = group.querySelector('.faq-group__panel');

      group.classList.toggle('active', isOpen);
      if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (panel) {
        if (isOpen) {
          panel.removeAttribute('inert');
        } else {
          panel.setAttribute('inert', '');
        }
      }
      if (!isOpen) closeFaqItems(group);
    }

    document.querySelectorAll('.faq-group__toggle').forEach(function (toggle) {
      if (toggle.dataset.faqReady === 'true') return;
      toggle.dataset.faqReady = 'true';

      toggle.addEventListener('click', function () {
        const group = this.closest('.faq-group');
        const root = this.closest('.faq-page') || this.closest('.faq_cta') || document;
        const isOpen = group.classList.contains('active');

        root.querySelectorAll('.faq-group').forEach(function (otherGroup) {
          setGroupOpen(otherGroup, false);
        });

        if (!isOpen) setGroupOpen(group, true);
      });
    });

    document.querySelectorAll('.faq-question').forEach(function (question) {
      if (question.dataset.faqReady === 'true') return;
      question.dataset.faqReady = 'true';

      question.addEventListener('click', function () {
        const item = this.parentElement;
        const answer = item.querySelector('.faq-answer');
        const faqRoot = item.closest('.faq-group') || item.closest('.faq_cta') || item.parentElement;

        if (item.classList.contains('active')) {
          item.classList.remove('active');
          answer.style.maxHeight = null;
        } else {
          closeFaqItems(faqRoot);
          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-viewer"] && !Shopify.designMode) return;
  try {
    (() => {
    const LOCK_CLASS = 'image-viewer-modal-open';

    function lockPageScroll() {
      const root = document.documentElement;
      const body = document.body;
      const current = Number(root.dataset.imageViewerOpenCount || '0');
      const next = current + 1;
      root.dataset.imageViewerOpenCount = String(next);
      if (next === 1) {
        root.classList.add(LOCK_CLASS);
        body.classList.add(LOCK_CLASS);
      }
    }

    function unlockPageScroll() {
      const root = document.documentElement;
      const body = document.body;
      const current = Number(root.dataset.imageViewerOpenCount || '0');
      const next = Math.max(0, current - 1);
      root.dataset.imageViewerOpenCount = String(next);
      if (next === 0) {
        root.classList.remove(LOCK_CLASS);
        body.classList.remove(LOCK_CLASS);
      }
    }

    const viewers = document.querySelectorAll('.js-image-viewer');
    viewers.forEach((viewer) => {
      if (viewer.dataset.viewerReady === 'true') return;
      viewer.dataset.viewerReady = 'true';

      const mainImage = viewer.querySelector('.image-viewer__main-image');
      const thumbs = Array.from(viewer.querySelectorAll('.image-viewer__thumb[data-full-url]'));
      const prevButton = viewer.querySelector('[data-action="prev"]');
      const nextButton = viewer.querySelector('[data-action="next"]');
      const openModalButton = viewer.querySelector('[data-action="open-modal"]');
      const modal = viewer.querySelector('[data-element="modal"]');
      const modalImage = viewer.querySelector('.image-viewer__modal-image');
      const modalCloseButton = viewer.querySelector('[data-action="close-modal"]');
      const modalPrevButton = viewer.querySelector('[data-action="modal-prev"]');
      const modalNextButton = viewer.querySelector('[data-action="modal-next"]');
      if (!mainImage || thumbs.length === 0) return;

      let currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      if (currentIndex < 0) currentIndex = 0;

      function updateModalImage(fullUrl, alt) {
        if (!modalImage) return;
        modalImage.src = fullUrl;
        modalImage.removeAttribute('data-modal-src');
        if (alt) modalImage.alt = alt;
      }

      function setActive(index, swapMainImage = true) {
        if (!thumbs[index]) return;
        currentIndex = index;
        const activeThumb = thumbs[index];
        const fullUrl = activeThumb.getAttribute('data-full-url');
        const alt = activeThumb.getAttribute('data-alt');
        if (!fullUrl) return;

        if (swapMainImage) {
          // The main image is rendered with a srcset/sizes, which the browser
          // prefers over src. Clear them so the selected image actually shows.
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = fullUrl;
          if (alt) mainImage.alt = alt;
        }

        thumbs.forEach((node, nodeIndex) => {
          node.classList.toggle('is-active', nodeIndex === currentIndex);
          if (nodeIndex === currentIndex) {
            node.setAttribute('aria-current', 'true');
          } else {
            node.removeAttribute('aria-current');
          }
        });

        if (modal && modal.open) {
          updateModalImage(fullUrl, alt);
        }
      }

      function goNext() {
        const nextIndex = (currentIndex + 1) % thumbs.length;
        setActive(nextIndex);
      }

      function goPrev() {
        const prevIndex = (currentIndex - 1 + thumbs.length) % thumbs.length;
        setActive(prevIndex);
      }

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => setActive(index));
      });

      if (prevButton) prevButton.addEventListener('click', goPrev);
      if (nextButton) nextButton.addEventListener('click', goNext);

      if (openModalButton && modal) {
        openModalButton.addEventListener('click', () => {
          if (!modal.open && typeof modal.showModal === 'function') {
            modal.showModal();
            lockPageScroll();
            updateModalImage(mainImage.currentSrc || mainImage.src, mainImage.alt);
          }
        });
      }

      if (modalCloseButton && modal) {
        modalCloseButton.addEventListener('click', () => modal.close());
      }
      if (modalPrevButton) modalPrevButton.addEventListener('click', goPrev);
      if (modalNextButton) modalNextButton.addEventListener('click', goNext);

      if (modal) {
        modal.addEventListener('click', (event) => {
          if (event.target === modal) modal.close();
        });
        modal.addEventListener('close', unlockPageScroll);
        modal.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goNext();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goPrev();
          } else if (event.key === 'Home') {
            event.preventDefault();
            setActive(0);
          } else if (event.key === 'End') {
            event.preventDefault();
            setActive(thumbs.length - 1);
          }
        });
      }

      viewer.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goNext();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goPrev();
        } else if (event.key === 'Home') {
          event.preventDefault();
          setActive(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          setActive(thumbs.length - 1);
        }
      });

      setActive(currentIndex, false);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
